import { createContext, useState } from "react";
interface IDefaultUserValues {
  id: any;
  email: string;
  email_verified_at: null;
  created_at: string;
  updated_at: string;
  first_name: string;
  last_name: string;
  mobile_number: string;
  role_id: any;
  status: string;
  token: string;
  status_name: string;
  role_name: string;
  role: {
    id: any;
    name: string;
    description: string;
    created_at: string;
    updated_at: string;
  };
}
interface ILoggedInUserContext {
  loggedInUserContext: null | IDefaultUserValues;
  setLoggedInUserContext: (values: null) => void;
}
export const LoggedInUserContext = createContext<ILoggedInUserContext>({
  loggedInUserContext: null,
  setLoggedInUserContext: (data: any) => data,
});
export const LoggedInUserContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [loggedInUserContext, setLoggedInUserContext] = useState<null>(null);
  return (
    <LoggedInUserContext.Provider
      value={{
        loggedInUserContext,
        setLoggedInUserContext: (values) => setLoggedInUserContext(values),
      }}
    >
      {children}
    </LoggedInUserContext.Provider>
  );
};
